<!-- Standalone preview page without sidebar/navbar -->
<div class="mail-preview-container">
  <!-- Header Section -->
  <!-- <div class="preview-toolbar">
    <div class="toolbar-content">
      <div class="toolbar-left">
        <mat-icon class="mail-icon">mail</mat-icon>
        <h1 class="preview-title">Email Campaign Preview</h1>
      </div>
      <div class="toolbar-right">
        <button mat-icon-button (click)="printEmail()" matTooltip="Print">
          <mat-icon>print</mat-icon>
        </button>
        <button mat-icon-button (click)="closeWindow()" matTooltip="Close">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
  </div> -->

  <!-- Main Email Preview Content -->
  <div class="preview-body">
    <div class="email-container">
      <!-- Email Card -->
      <div class="email-card">
        <ng-container *ngIf="!previewOnlyBody">
        <!-- Email Header Section -->
        <div class="email-header">
          <div class="header-row">
            <!-- <div class="header-icon">
              <mat-icon>inbox</mat-icon>
            </div> -->
            <div class="header-content">
              <div class="campaign-badge" *ngIf="campaignName">
                <!-- <mat-icon class="badge-icon">campaign</mat-icon> -->
                <span>{{ campaignName }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Email Metadata Section -->
        <div class="email-metadata-section">
          <!-- From -->
          <div class="metadata-field">
            <div class="field-label">
              <mat-icon class="field-icon">person</mat-icon>
              <span class="label-text">From</span>
            </div>
            <div class="field-value">
              <div class="sender-info" *ngIf="senderName; else noSender">
                <span class="sender-name">{{ senderName }}</span>
                <span class="sender-email" *ngIf="senderEmail">&lt;{{ senderEmail }}&gt;</span>
              </div>
              <ng-template #noSender>
                <span class="placeholder-text">No sender specified</span>
              </ng-template>
            </div>
          </div>

          <!-- To -->
          <div class="metadata-field">
            <div class="field-label">
              <mat-icon class="field-icon">group</mat-icon>
              <span class="label-text">To</span>
            </div>
            <div class="field-value">
              <div class="recipient-info" *ngIf="recipientName; else noRecipient">
                <!-- <mat-chip class="recipient-chip"> -->
                  <!-- <mat-icon class="chip-icon">label</mat-icon> -->
                   <span class="recipient-name">
                      {{ recipientName }}
                   </span>
                <!-- </mat-chip> -->
              </div>
              <ng-template #noRecipient>
                <span class="placeholder-text">No recipients selected</span>
              </ng-template>
            </div>
          </div>

          <!-- Subject -->
          <div class="metadata-field">
            <div class="field-label">
              <mat-icon class="field-icon">subject</mat-icon>
              <span class="label-text">Subject</span>
            </div>
            <div class="field-value">
              <span class="subject-text" *ngIf="subject; else noSubject">
                {{ subject }}
              </span>
              <ng-template #noSubject>
                <span class="placeholder-text">No subject</span>
              </ng-template>
            </div>
          </div>

          <!-- Schedule Time -->
          <div class="metadata-field" *ngIf="scheduledDateTime">
            <div class="field-label">
              <mat-icon class="field-icon">schedule</mat-icon>
              <span class="label-text">Scheduled</span>
            </div>
            <div class="field-value">
              <div class="schedule-info">
                <mat-icon class="schedule-icon">event</mat-icon>
                <span>{{ scheduledDateTime }}</span>
              </div>
            </div>
          </div>

          <div class="metadata-field" *ngIf="attachments?.length">
            <div class="field-label">
              <mat-icon class="field-icon">attachment</mat-icon>
              <span class="label-text">Attachment</span>
            </div>
            <div class="field-value">
              <div class="attached-list" *ngFor="let file of attachments; let i = index"
                [matTooltip]="file.name?.length > 30 ? file.name : ''">
                {{( file.name | truncate : 30).text }}
                <!-- <span class="close" (click)="removeAttachment(i)"></span> -->
              </div>
            </div>
          </div>
        </div>

        <!-- Divider -->
        <mat-divider class="email-divider"></mat-divider>
        </ng-container>

        <!-- Email Body Section -->
        <div class="email-body-section">
          <!-- <div *ngIf="emailBody; else noContent" 
               [innerHTML]="emailBody" 
               class="email-body-content">
          </div> -->
          <div class="preview-content-iframe" *ngIf="emailBody; else noContent" >
            <iframe #previewFrame class="preview-iframe" sandbox="allow-same-origin allow-popups">
            </iframe>
          </div>
          <ng-template #noContent>
            <div class="no-content-container">
              <mat-icon class="no-content-icon">drafts</mat-icon>
              <h3 class="no-content-title">No Email Content</h3>
              <p class="no-content-text">
                The email body is empty. Please add content to preview.
              </p>
            </div>
          </ng-template>
        </div>

        <!-- Email Footer -->
        <!-- <div class="email-footer" *ngIf="emailBody">
          <mat-divider></mat-divider>
          <div class="footer-content">
            <mat-icon class="footer-icon">info_outline</mat-icon>
            <span class="footer-text">This is a preview of how your email will appear to recipients</span>
          </div>
        </div> -->
      </div>
    </div>
  </div>

  <!-- Bottom Action Bar -->
  <!-- <div class="action-bar" *ngIf="emailBody">
    <div class="action-content">
      <button mat-raised-button color="primary" (click)="printEmail()">
        <mat-icon>print</mat-icon>
        Print Preview
      </button>
      <button mat-stroked-button (click)="closeWindow()">
        Close Window
      </button>
    </div>
  </div> -->
</div>
